// A wistia.com/s/ showcase id here 200s with an HTML error page and the player spins forever; this must be the media hashed id.
export const VIDEO_ID = "fuq881tc78";
export const VIDEO_URL = "https://fast.wistia.com/embed/medias/fuq881tc78.m3u8";
export const LOOP_MP4 =
  "https://cdn.sanity.io/files/4bgok82s/monorepo-static-assets/0e484b72ed41d50fe5434f22d676c68a0f815a63.mp4";
export const LOOP_POSTER =
  "https://cdn.sanity.io/images/4bgok82s/monorepo-static-assets/00362cc73d72cca512b0cda1982ca36e7794636a-1280x720.webp";
export const HERO_BACKGROUND =
  "https://cdn.sanity.io/images/4bgok82s/monorepo-static-assets/6ab34197f5f1c900c064a9cac9c136c19c989eab-516x738.webp";
